import { Box, Grid, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import FetchDataToIntegrationServerFromAgentCard from '../DataManagement/FetchDataToIntegrationServerFromAgentCard';
import { PageContainer } from 'components/styled';
import StandardPageHeader from 'components/StandardPageHeader';

const CsmToolsPage = () => {
  // Note: Tenant/Realm dropdowns flow removed - not needed for this page
  // Forms have their own tenant/realm selectors

  return (
    <PageContainer>
      <Helmet title="CSM Tools" />

      <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={4}>
        <StandardPageHeader
          title="CSM Tools"
          subtitle="Customer Success Manager toolset for client operations"
          icon="CSM"
          sx={{ mb: 0 }}
        />
      </Box>

      <Grid container spacing={3} alignItems="stretch">
        <Grid size={12}>
          <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
            Data Operations
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <FetchDataToIntegrationServerFromAgentCard shouldShowWarningBeforeSubmission={true} />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default CsmToolsPage;
